export default __webpack_public_path__ + "static/spet4-f3c4cf3b5dc835f3373e4079ad765b47.jpg";